for (const container of document.querySelectorAll<HTMLElement>(
  ".tabbed-content"
)) {
  // Get the tabs in this tabbed content
  const tabs = container.querySelectorAll<HTMLElement>(".tabbed-content__tab");

  // Get the tab contents corresponding to each tab item
  const tabToContentItem = new Map<HTMLElement, HTMLElement>();
  for (const tab of tabs) {
    const content = container?.querySelector<HTMLElement>(
      `.tabbed-content__content[data-id="${tab.dataset.id}"]`
    );
    if (content != null) {
      tabToContentItem.set(tab, content);
    }
  }

  // Set up the click action for tabs
  function handleClick(event: Event): void {
    for (const tab of tabs) {
      const active = tab === event.currentTarget;
      tabToContentItem.get(tab)?.classList.toggle("active", active);
      tab.classList.toggle("active", active);
    }
  }
  for (const tab of tabs) {
    tab.addEventListener("click", handleClick);
  }

  // Set active tab based on hash
  function setActiveTab(): void {
    const hash = window.location.hash ? window.location.hash.slice(1) : null;
    const hashTab = container?.querySelector<HTMLElement>(
      `[data-id="${hash}"]`
    );

    if (hash && hashTab) {
      for (const tab of tabs) {
        const active = tab.dataset.id === hash;
        tabToContentItem.get(tab)?.classList.toggle("active", active);
        tab.classList.toggle("active", active);
        tab.scrollIntoView();
      }
    }
  }

  window.addEventListener("load", setActiveTab);
  window.addEventListener("hashchange", setActiveTab);
}
